export default __webpack_public_path__ + "static/media/logo-melhor-envio.9ada0e15.png";